function centsToDollars(cents: number): number {
  return cents / 100;
}

const wholeFormatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
const decimalFormatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

export function formatCents(cents: number): string {
  const dollars = centsToDollars(cents);
  return Number.isInteger(dollars) ? wholeFormatter.format(dollars) : decimalFormatter.format(dollars);
}
